import { z } from 'zod';

export const underwearPromotionSchema = z.object({
  name: z.string().trim().min(1, 'Champ requis'),
  description: z.string().trim().min(1, 'Champ requis'),
  link: z.string().trim().min(1, 'Champ requis'),
  timeStart: z.coerce.number().int().min(0, 'Doit être positif'),
  occurrence: z.coerce.number().int().min(1, 'Doit être au moins 1'),
  nthOpen: z.coerce.number().int().min(1, 'Doit être au moins 1'),
  file: z.instanceof(File),
});

export const updateUnderwearPromotionSchema = underwearPromotionSchema.extend({
  file: z.instanceof(File).optional(),
});

export type UnderwearPromotionSchemaType = z.infer<
  typeof underwearPromotionSchema
>;
export type UpdateUnderwearPromotionSchemaType = z.infer<
  typeof updateUnderwearPromotionSchema
>;
